<template>
  <router-view />
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  background-color: #f5f7fa;
}

#app {
  height: 100vh;
}

/* 全局滚动条美化 */
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

::-webkit-scrollbar-thumb {
  background: #c0c4cc;
  border-radius: 3px;
}

::-webkit-scrollbar-thumb:hover {
  background: #909399;
}

/* 卡片统一样式 */
.el-card {
  border-radius: 12px !important;
  border: none !important;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05) !important;
  transition: all 0.3s ease;
}

.el-card:hover {
  box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.08) !important;
}

.el-card__header {
  border-bottom: 1px solid #f0f2f5 !important;
  padding: 18px 24px !important;
}

/* 表格美化 */
.el-table {
  border-radius: 8px;
  overflow: hidden;
}

.el-table th {
  background-color: #f8f9fb !important;
  color: #606266;
  font-weight: 600;
  height: 48px;
}

.el-table td {
  height: 52px;
}

.el-table--striped .el-table__body tr.el-table__row--striped td {
  background-color: #fafbfc;
}

.el-table__row:hover > td {
  background-color: #f5f7fa !important;
}

/* 按钮统一样式 */
.el-button {
  border-radius: 8px !important;
  font-weight: 500;
  transition: all 0.2s ease;
}

.el-button--primary {
  background: linear-gradient(135deg, #409EFF 0%, #66b1ff 100%) !important;
  border: none !important;
  box-shadow: 0 2px 8px rgba(64, 158, 255, 0.3);
}

.el-button--primary:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(64, 158, 255, 0.4);
}

.el-button--success {
  background: linear-gradient(135deg, #67C23A 0%, #85ce61 100%) !important;
  border: none !important;
  box-shadow: 0 2px 8px rgba(103, 194, 58, 0.3);
}

.el-button--danger {
  background: linear-gradient(135deg, #F56C6C 0%, #f78989 100%) !important;
  border: none !important;
  box-shadow: 0 2px 8px rgba(245, 108, 108, 0.3);
}

/* 输入框美化 */
.el-input__inner {
  border-radius: 8px !important;
  transition: all 0.2s ease;
}

.el-input__inner:focus {
  box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.2);
}

/* 对话框美化 */
.el-dialog {
  border-radius: 16px !important;
  overflow: hidden;
}

.el-dialog__header {
  background: linear-gradient(135deg, #f5f7fa 0%, #ffffff 100%);
  border-bottom: 1px solid #ebeef5;
  padding: 20px 24px !important;
}

.el-dialog__title {
  font-weight: 600;
  color: #303133;
}

/* 分页美化 */
.el-pagination {
  padding: 16px 0;
}

.el-pagination .el-pager li {
  border-radius: 6px;
  transition: all 0.2s ease;
}

.el-pagination .el-pager li.active {
  background: linear-gradient(135deg, #409EFF 0%, #66b1ff 100%);
  box-shadow: 0 2px 8px rgba(64, 158, 255, 0.3);
}

/* 标签美化 */
.el-tag {
  border-radius: 6px !important;
  font-weight: 500;
  padding: 0 12px;
  height: 28px;
  line-height: 26px;
}

/* 菜单美化 */
.el-menu {
  border-right: none !important;
}

.el-menu-item {
  border-radius: 0 24px 24px 0;
  margin-right: 12px;
  transition: all 0.2s ease;
}

.el-menu-item.is-active {
  background: linear-gradient(135deg, #409EFF 0%, #66b1ff 100%) !important;
  box-shadow: 0 2px 8px rgba(64, 158, 255, 0.3);
}

/* 上传组件美化 */
.el-upload {
  border-radius: 8px;
}

/* 开关美化 */
.el-switch__core {
  border-radius: 12px !important;
}

/* 空状态美化 */
.el-empty__description {
  color: #909399;
  font-size: 14px;
}

/* 加载动画 */
.el-loading-spinner .circular {
  width: 32px;
  height: 32px;
}

/* 表单标签 */
.el-form-item__label {
  font-weight: 500;
  color: #606266;
}

/* 分割线 */
.el-divider__text {
  font-weight: 600;
  color: #909399;
  background-color: #f5f7fa;
  padding: 0 16px;
}

/* 下拉菜单 */
.el-dropdown-menu {
  border-radius: 8px !important;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1) !important;
}

/* 消息提示 */
.el-message {
  border-radius: 8px !important;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1) !important;
}

/* 选择器 */
.el-select-dropdown {
  border-radius: 8px !important;
}

/* 数字输入框 */
.el-input-number .el-input__inner {
  text-align: center;
}

/* 文本域 */
.el-textarea__inner {
  border-radius: 8px !important;
  padding: 12px;
}
</style>
